<template>
  <div class="l-content">
    <div class="row">
      <div class="col-xs-16 col-xs-offset-1">
          <div v-if="above" class="four-cols__above">
            <slot name="above"></slot>
          </div>
          <div class="four-cols">
            <slot></slot>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FourCols',
  props: {
    above: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../scss/vars';
  .four-cols {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    // margin-bottom: 30px;
    margin-right: -15px;
    @media (min-width: 768px) {
      // margin-bottom: 50px;
      margin-right: -36px;
    }
    &__above {
      margin-bottom: 50px;
      h2 {
        color: $grey;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FourCols.vue